import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Search, Download, FileText, BookOpen, BarChart2 } from 'lucide-react';
const resources = [{
  title: 'National Agriculture Policy',
  category: 'Policy Document',
  size: '2.4 MB PDF',
  icon: FileText
}, {
  title: 'Agricultural Sector Strategic Plan',
  category: 'Strategic Plan',
  size: '5.1 MB PDF',
  icon: BookOpen
}, {
  title: 'Annual Sector Performance Report',
  category: 'Annual Report',
  size: '8.7 MB PDF',
  icon: BarChart2
}];
const filters = ['All', 'Policies', 'Strategic Plans', 'Annual Reports', 'Guidelines', 'Extension Materials'];
export function KnowledgeHub() {
  return <section className="py-16 bg-uganda-green text-white" data-id="element-250">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-251">
        <div className="text-center mb-10" data-id="element-252">
          <h2 className="text-3xl font-bold mb-4" data-id="element-253">Knowledge Hub & Resources</h2>
          <p className="text-green-100 max-w-2xl mx-auto mb-8" data-id="element-254">
            Access official publications, research data, agricultural
            guidelines, and policy documents.
          </p>

          {/* Search Bar */}
          <div className="max-w-2xl mx-auto relative mb-8" data-id="element-255">
            <input type="text" placeholder="Search for documents, guidelines, reports..." className="w-full pl-5 pr-12 py-4 rounded-full text-uganda-black focus:outline-none focus:ring-2 focus:ring-uganda-yellow shadow-lg" data-id="element-256" />
            <button className="absolute right-2 top-1/2 -translate-y-1/2 bg-uganda-yellow text-uganda-black p-2.5 rounded-full hover:bg-yellow-500 transition-colors" data-id="element-257">
              <Search className="w-5 h-5" data-id="element-258" />
            </button>
          </div>

          {/* Filter Chips */}
          <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-259">
            {filters.map((filter, index) => <button key={index} className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${index === 0 ? 'bg-uganda-yellow text-uganda-black' : 'bg-white/10 hover:bg-white/20 text-white border border-white/20'}`} data-id="element-260">
                {filter}
              </button>)}
          </div>
        </div>

        {/* Resource Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10" data-id="element-261">
          {resources.map((resource, index) => {
          const Icon = resource.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-white rounded-xl p-6 text-uganda-black flex flex-col h-full shadow-lg" data-id="element-262">
                <div className="flex items-start justify-between mb-4" data-id="element-263">
                  <div className="w-10 h-10 rounded-lg bg-green-50 text-uganda-green flex items-center justify-center" data-id="element-264">
                    <Icon className="w-5 h-5" data-id="element-265" />
                  </div>
                  <span className="text-xs font-bold text-gray-500 uppercase tracking-wider bg-gray-100 px-2 py-1 rounded" data-id="element-266">
                    {resource.category}
                  </span>
                </div>
                <h3 className="font-bold text-lg mb-2 flex-grow" data-id="element-267">
                  {resource.title}
                </h3>
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-100" data-id="element-268">
                  <span className="text-sm text-gray-500" data-id="element-269">{resource.size}</span>
                  <button className="flex items-center text-sm font-semibold text-uganda-green hover:text-green-800 transition-colors" data-id="element-270">
                    <Download className="w-4 h-4 mr-1" data-id="element-271" /> Download
                  </button>
                </div>
              </motion.div>;
        })}
        </div>

        <div className="text-center" data-id="element-272">
          <Link to="/resources" className="inline-block bg-transparent border-2 border-white hover:bg-white hover:text-uganda-green text-white px-8 py-3 rounded-md font-semibold transition-colors" data-id="element-273">
            View All Resources
          </Link>
        </div>
      </div>
    </section>;
}